export default "__VITE_ASSET__85365dac__"